export default __webpack_public_path__ + "static/media/closet3-1920w.5b1b7047.png";